export const data = {
  heading: "Native Mobile App Development Cost & Timeline",
  paragraph: "Native development is an investment in your product’s longevity. Costs vary based on feature complexity and whether you are launching on one or both platforms.",
  lastParagraph:"Factors affecting your pricing: API complexity, custom animations, offline data sync, and specialized hardware integrations (IoT/BLE).",
  CTA:"Request a Custom Quote",
    tableData: {
    thead: [
      "App Complexity",
      "iOS or Android (Single)",
      "Both Platforms",
      "Estimated Timeline"
    ],
    tbody: [
      [
        "Simple MVP",
        "$30k – $80k",
        "$70k – $140k",
        "2 – 4 Months"
       
      ],
      [
        "Medium Complexity",
        "$70k – $150k",
        "$140k – $250k",
        "4 – 6 Months"
      ],
      [
        "Enterprise / Complex",
        "$130k+",
        "$250k+",
        "6 – 12 Months"
      ]
    
    
    ],
  },
};